import React from 'react';

import { setCarouselHeight } from '../../../shared/components/carousel';
import AccessoriesCarousel from '../pdp-acc-carousel';
import CategorizedAccCarousel from '../pdp-cat-acc-carousel';

import '../../css/pdp-accessories.less';

class Accessories extends React.Component {

    constructor(props) {
        super(props);
        this.carousel = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if(this.props.isActive && prevProps.isActive !== this.props.isActive && this.carousel) {
            setCarouselHeight(this.carousel.current);
        }
    }

    render() {
        const products = this.props.product.xsell.slice(0,4);
        const tabHeader = products.length > 0 ? 'Top matches for your product' :
        'No matching accessories found';
        return (
            <div className='pdp-acc'>
                <div className='pdp-tab-header'>{tabHeader}</div>
                <AccessoriesCarousel products = { products } carouselRef={ this.carousel } setCarouselHeight={()=>setCarouselHeight(this.carousel.current)}/>
                {products.length > 0 && <CategorizedAccCarousel isActive={ this.props.isActive } product={ this.props.product } /> }
            </div>
        )
    }

}

export default Accessories;
